module.exports = __webpack_public_path__ + "img/button_Edit.797c5231.svg";